import { useState } from "react";
import { generateSoa } from "./api";
import moment from "moment";

export const useHandleGenerateSoa = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const generate = async ({as_at_date, start_date, end_date, companies }) => {

        setLoading(true);
        setError(null);

        try {
            const isMultiple = companies.length > 1;

            const response = await generateSoa({ as_at_date, start_date, end_date, companies, download: true });

            const url = URL.createObjectURL(response);

            const link = document.createElement("a");

            link.href = url;

            link.download = isMultiple
                ? `SOA_Batch_${moment().format("YYYYMMDD_HHmmss")}.zip`
                : `SOA_${companies[0].bp_code}_${moment().format(
                      "YYYYMMDD_HHmmss"
                  )}.pdf`;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(url);
        } catch (error) {
            setError(
                error.response?.status === 404
                    ? "No outstanding invoices found for the selected companies"
                    : "Failed to generate Statement of Account"
            );

            throw error;
        } finally {
            setLoading(false);
        }
    };

    return {
        generate,
        loading,
        error,
        setError,
    };
};
